@for (star of stars; track star) {
  <mat-icon>
    {{ star }}
  </mat-icon>
}
